import React from 'react';
import clsx from 'clsx';
import { PlaylistReleasesModal } from '@components/modals/PlaylistReleases';
import { ModalContext, ModalType } from '@context/modal';
import type { FragmentType } from '@graphql/reactQuery';
import type { ReleasePillFragmentDoc } from '@graphql/reactQuery';
import { SPACE } from '@utils/constants';
import { ReleasePill } from '../components/ReleasePill';
import { FeedListViewSubText } from '../components/shared';
import { TotalOtherText } from './TotalOtherText';

export const FeaturedReleasePills = ({
  featuredReleases,
  totalOtherReleases,
  hasOtherReleases,
  playlistId,
  actionType,
  actionId,
  forceMobileView,
}: {
  featuredReleases: FragmentType<ReleasePillFragmentDoc>[];
  totalOtherReleases: number;
  hasOtherReleases?: boolean;
  playlistId: string;
  actionType: 'removed' | 'added';
  actionId: string;
  forceMobileView: boolean;
}) => {
  const featuredReleaseCount = featuredReleases.length;
  const { openModal } = ModalContext.useContainer();

  const releasePills = featuredReleases.map((release, index) => {
    const showAnd =
      featuredReleaseCount !== 1 && index === featuredReleaseCount - 1 && !hasOtherReleases;
    return (
      <>
        {showAnd && (
          <>
            <FeedListViewSubText>and</FeedListViewSubText>
            {SPACE}
          </>
        )}
        <div className="mx-1 flex items-center">
          <ReleasePill release={release} />
        </div>

        {index === featuredReleaseCount - 1 && hasOtherReleases && (
          <TotalOtherText
            forceMobileView={forceMobileView}
            count={totalOtherReleases}
            onClick={() => {
              openModal(ModalType.PLAYLIST_ACTIONS, {
                body: (
                  <PlaylistReleasesModal
                    actionId={actionId}
                    type={actionType}
                    playlistId={playlistId}
                  />
                ),
              });
            }}
          />
        )}
      </>
    );
  });

  return (
    <div className={clsx('hidden', !forceMobileView && 'lg:flex lg:items-center')} key={actionId}>
      {releasePills}
    </div>
  );
};
